
                            const shader = `precision highp float;
uniform mat4 modelViewMatrix;
uniform mat4 projectionMatrix;

attribute vec2 uv;
attribute vec3 position;

varying vec2 vUv;

void main() {
	vUv = uv;
	gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}`;

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['vertexShader'] = shader;
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        